import { action } from 'satcheljs';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import SmimeViewState from '../store/schema/SmimeViewState';
import SmimeContext from '../store/schema/SmimeContext';

/**
 * Action fired when S/MIME encoding process encounters an error.
 */
export default action(
    'setSmimeErrorCode',
    (
        smimeViewState: SmimeViewState,
        errorCode: SmimeErrorStateEnum,
        errorContext: SmimeContext
    ) => ({
        smimeViewState,
        errorCode,
        errorContext,
    })
);
